var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('a',{attrs:{"href":"#"}},[_c('aside',{staticClass:"aside",style:('background-image:url(images/banners/' + _vm.backgroundImage + ' ) ')})])])}
var staticRenderFns = []

export { render, staticRenderFns }